<canvas #sigPad class="canvas"></canvas>
<button mat-icon-button type="button" matTooltip="{{ 'clear' | translate }}" (click)="clear()" *ngIf="!disabled" class="clear-button">
  <mat-icon svgIcon="undo"></mat-icon>
</button>
